import blue from '@material-ui/core/colors/blue';
import red from '@material-ui/core/colors/red';

import { createTheme } from '@material-ui/core/styles'

export const theme = createTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: blue,
    secondary: red,
  },
  status: {
    danger: 'orange',
  },
});
